import { TemplatePage } from './types';
import { TEMPLATES_AMOUNT } from '@anm/constants/templates_amount';

const naturePage: TemplatePage = {
  header: {
    color: '#BDECE2',
    icon: 'images/video-templates/nature-environment.jpg',
    title: 'Nature and Environment Video Templates Collection',
    title_meta: '50+ Free and Customizable Nature Video Templates',
    description_meta:
      'Get a set of 50+ video templates inspired by the beauty of nature. Discover the wonders of the planet and ' +
      'help protect it with a help of impactful video content.',
    description:
      'This collection comprises video templates to share breathtaking landscapes, marvel at beautiful wildlife, ' +
      'and provoke the desire for a careful and respectful attitude towards the natural environment and its resources.'
  },
  footer: {
    category: 'Nature & Environment',
    description:
      'Ready-to-use customizable video templates help you get more creative about your video production even if you ' +
      'don’t have much experience in making videos. Create impactful and appealing videos from templates in a matter of ' +
      `minutes. Choose from over ${TEMPLATES_AMOUNT} video templates tailored for different industries, businesses and use` +
      ' cases. Use ' +
      'Wave.video’s powerful yet user-friendly video editor to customize any template you like and turn it into your ' +
      'branded content.'
  },
  content: [
    {
      type: 'templates',
      title: 'nature',
      search: { category: '/Industries/Nature & Environment' }
    },
    {
      type: 'stocks',
      title: 'nature',
      search: { name: 'nature' }
    },
    { type: 'calendar' }
  ]
};

export default naturePage;
